import constants from '../../constants';

const { NAMESPACE: GLOBAL_NAMESPACE } = constants;

const NAMESPACE = `${GLOBAL_NAMESPACE}/settings` as const;

export default {
  NAMESPACE,
};
